import { render, staticRenderFns } from "./addempowertype.vue?vue&type=template&id=7810e7ad&scoped=true&"
import script from "./addempowertype.vue?vue&type=script&lang=js&"
export * from "./addempowertype.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./addempowertype.vue?vue&type=style&index=1&id=7810e7ad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7810e7ad",
  null
  
)

export default component.exports